﻿import axios from 'axios'
import FileSaver from 'file-saver'
import qs from 'qs'
import fn from '../../utils/functions'
import dayjs from 'dayjs';

// Normaliza fechas en profundidad para evitar que qs.stringify destruya objetos Dayjs
export function convertDates(obj) {
  if (obj == null) return obj;

  // Detecta Day.js correctamente
  if (dayjs.isDayjs(obj)) {
    return obj.toISOString();
  }

  // Detecta Date nativo
  if (obj instanceof Date) {
    return obj.toISOString();
  }

  // Arrays → recorrer
  if (Array.isArray(obj)) {
    return obj.map(item => convertDates(item));
  }

  // Objetos → recorrer recursivamente
  if (typeof obj === 'object') {
    const newObj = {};
    for (const key in obj) {
      newObj[key] = convertDates(obj[key]);
    }
    return newObj;
  }

  
  return obj;
}

function initSession () {
  const session = {
    // Servicios
    services: {
      tableData: [],
      totalServices: 0
    },
    queryServices: {
      page: 0,
      size: 20,
      sort: 'name,ASC',
      creationDateTimeFrom: '',
      creationDateTimeTo: ''
    },
    listSelectedFiltersServices: [],

    // Empresas de un servicio
    partiesService: {
      tableData: [],
      totalPartiesService: 0
    },

    queryPartiesService: {
      page: 0,
      size: 20,
      sort: 'tradeName,ASC',
      partyName: null,
      partyTaxIdNumber: null,
      partyRegisterDate: null,
      buyer: null,
      sponsor: null,
      seller: null,
      active: null,
      country: null
    },
    listSelectedFiltersPartiesService: [],

    // Relaciones comerciales
    commercialRelation: {
      tableData: [],
      totalCommercialRelation: 0
    },

    queryCommercialRelation: {
      id: null,
      page: 0,
      size: 20,
      buyer: null,
      seller: null,
      serviceId: null,
      partyId: null
    },
    listSelectedFiltersCommercialRelation: [],
    // Datos Select Filtros Servicios
    optionsFilterNameServices: [],
    optionsFilterCodeServices: [],
    optionsFilterSecurityCodeServices: [],
    optionsFilterPartyNifServices: [],
    optionsFilterPartyNameServices: [],
    optionsFilterDateCreationServices: [],

    // Datos Select Filtros Empresas Servicios
    optionsFilterPartyNamePartiesServices: [],
    optionsFilterPartyTaxIdNumberPartiesServices: [],
    optionsFilterPartyRegisterDatePartiesServices: [],
    optionsFilterPartyBuyerPartiesServices: [],
    optionsFilterPartyPropietaryPartiesServices: [],
    optionsFilterPartySellerPartiesServices: [],
    optionsFilterPartyActivePartiesServices: [],
    optionsFilterPartyCountryPartiesServices: [],

    optionsFilterPartyAllCommercialRelation: [],
    optionsFilterPartyBuyerCommercialRelation: [],
    optionsFilterPartySellerCommercialRelation: []
  }
  return session
}
function initLocal () {
  const local = {

    // Columnas Tabla Servicios
    isShowNameServices: true,
    isShowCodeServices: true,
    isShowIsSenderServices: true,
    isShowIsReceiverServices: true,
    isShowCreationDateTimeServices: true,
    isShowStatusServices: true,

    // Columnas Tabla Empresas de un Servicio
    isShowNameServiceParty: true,
    isShowTaxServiceParty: true,
    isShowEnabledServiceParty: true,
    isShowCountryServiceParty: true,
    isShowSellerServiceParty: true,
    isShowBuyerServiceParty: true,
    isShowThirdServiceParty: true,
    isShowSponsorServiceParty: true,
    isShowProvinceServiceParty: true,
    isShowCreationDateTimeServiceParty: true,
    isShowRegisterServiceParty: true,

    // Columnas Tabla Relaciones comerciales
    isShowBuyerNameCommercialRelation: true,
    isShowSellerNameCommercialRelation: true,
    isShowChannelCommercialRelation: true
  }
  return local
}
function setByUserLocalServ () {
  const local = {
    // Columnas Tabla Servicios
    isShowNameServices: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowNameServices,
    isShowCodeServices: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowCodeServices,
    isShowIsSenderServices: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowIsSenderServices,
    isShowIsReceiverServices: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowIsReceiverServices,
    isShowCreationDateTimeServices: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowCreationDateTimeServices,
    isShowStatusServices: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowStatusServices,

    // Columnas Tabla Empresas de un Servicio
    isShowNameServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowNameServiceParty,
    isShowTaxServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowTaxServiceParty,
    isShowEnabledServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowEnabledServiceParty,
    isShowCountryServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowCountryServiceParty,
    isShowSellerServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowSellerServiceParty,
    isShowBuyerServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowBuyerServiceParty,
    isShowThirdServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowThirdServiceParty,
    isShowSponsorServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowSponsorServiceParty,
    isShowProvinceServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowProvinceServiceParty,
    isShowCreationDateTimeServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowCreationDateTimeServiceParty,
    isShowRegisterServiceParty: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowRegisterServiceParty,

    // Columnas Tabla Relaciones comerciales
    isShowBuyerNameCommercialRelation: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowBuyerNameCommercialRelation,
    isShowSellerNameCommercialRelation: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowSellerNameCommercialRelation,
    isShowChannelCommercialRelation: JSON.parse(localStorage.getItem(state.userConfigLocalStorage)).servicios.isShowChannelCommercialRelation
  }
  return local
}
// state
const state = {
  userConfigLocalStorage: '',
  local: {
    // Columnas Tabla Servicios
    isShowNameServices: true,
    isShowCodeServices: true,
    isShowIsSenderServices: true,
    isShowIsReceiverServices: true,
    isShowCreationDateTimeServices: true,
    isShowStatusServices: true,

    // Columnas Tabla Empresas de un Servicio
    isShowNameServiceParty: true,
    isShowTaxServiceParty: true,
    isShowEnabledServiceParty: true,
    isShowCountryServiceParty: true,
    isShowSellerServiceParty: true,
    isShowBuyerServiceParty: true,
    isShowThirdServiceParty: true,
    isShowSponsorServiceParty: true,
    isShowProvinceServiceParty: true,
    isShowCreationDateTimeServiceParty: true,
    isShowRegisterServiceParty: true,

    // Columnas Tabla Relaciones comerciales
    isShowBuyerNameCommercialRelation: true,
    isShowSellerNameCommercialRelation: true,
    isShowChannelCommercialRelation: true
  },
  session: initSession()
}

// getters
const getters = {
  // Datos Tablas Servicios
  services: state => {
    return state.session.services
  },
  queryServices: state => {
    return state.session.queryServices
  },
  listSelectedFiltersServices: state => {
    return state.session.listSelectedFiltersServices
  },

  // Datos Tablas Empresas de un servicio
  partiesService: state => {
    return state.session.partiesService
  },
  queryPartiesService: state => {
    return state.session.queryPartiesService
  },
  listSelectedFiltersPartiesService: state => {
    return state.session.listSelectedFiltersPartiesService
  },

  // Datos Relaciones comerciales
  commercialRelation: state => {
    return state.session.commercialRelation
  },
  queryCommercialRelation: state => {
    return state.session.queryCommercialRelation
  },
  listSelectedFiltersCommercialRelation: state => {
    return state.session.listSelectedFiltersCommercialRelation
  },

  // Columnas Tabla Servicios
  isShowNameServices: state => {
    return state.local.isShowNameServices
  },
  isShowCodeServices: state => {
    return state.local.isShowCodeServices
  },
  isShowIsSenderServices: state => {
    return state.local.isShowIsSenderServices
  },
  isShowIsReceiverServices: state => {
    return state.local.isShowIsReceiverServices
  },
  isShowCreationDateTimeServices: state => {
    return state.local.isShowCreationDateTimeServices
  },
  isShowStatusServices: state => {
    return state.local.isShowStatusServices
  },

  // Columnas Tabla Empresas de un Servicio
  isShowNameServiceParty: state => {
    return state.local.isShowNameServiceParty
  },
  isShowTaxServiceParty: state => {
    return state.local.isShowTaxServiceParty
  },
  isShowEnabledServiceParty: state => {
    return state.local.isShowEnabledServiceParty
  },
  isShowCountryServiceParty: state => {
    return state.local.isShowCountryServiceParty
  },
  isShowSellerServiceParty: state => {
    return state.local.isShowSellerServiceParty
  },
  isShowBuyerServiceParty: state => {
    return state.local.isShowBuyerServiceParty
  },
  isShowThirdServiceParty: state => {
    return state.local.isShowThirdServiceParty
  },
  isShowSponsorServiceParty: state => {
    return state.local.isShowSponsorServiceParty
  },
  isShowProvinceServiceParty: state => {
    return state.local.isShowProvinceServiceParty
  },
  isShowCreationDateTimeServiceParty: state => {
    return state.local.isShowCreationDateTimeServiceParty
  },
  isShowRegisterServiceParty: state => {
    return state.local.isShowRegisterServiceParty
  },

  // Columnas Tabla Relaciones Comerciales
  isShowBuyerNameCommercialRelation: state => {
    return state.local.isShowBuyerNameCommercialRelation
  },
  isShowSellerNameCommercialRelation: state => {
    return state.local.isShowSellerNameCommercialRelation
  },
  isShowChannelCommercialRelation: state => {
    return state.local.isShowChannelCommercialRelation
  },

  // Datos Select Filtros Servicos
  optionsFilterNameServices: state => {
    return state.session.optionsFilterNameServices
  },
  optionsFilterCodeServices: state => {
    return state.session.optionsFilterCodeServices
  },
  optionsFilterSecurityCodeServices: state => {
    return state.session.optionsFilterSecurityCodeServices
  },
  optionsFilterPartyNifServices: state => {
    return state.session.optionsFilterPartyNifServices
  },
  optionsFilterPartyNameServices: state => {
    return state.session.optionsFilterPartyNameServices
  },
  optionsFilterDateCreationServices: state => {
    return state.session.optionsFilterDateCreationServices
  },
  optionsFilterPartyNamePartiesServices: state => {
    return state.session.optionsFilterPartyNamePartiesServices
  },
  optionsFilterPartyTaxIdNumberPartiesServices: state => {
    return state.session.optionsFilterPartyTaxIdNumberPartiesServices
  },
  optionsFilterPartyAllCommercialRelation: state => {
    return state.session.optionsFilterPartyAllCommercialRelation
  },
  optionsFilterPartyBuyerCommercialRelation: state => {
    return state.session.optionsFilterPartyBuyerCommercialRelation
  },
  optionsFilterPartySellerCommercialRelation: state => {
    return state.session.optionsFilterPartySellerCommercialRelation
  },
  optionsFilterPartyRegisterDatePartiesServices: state => {
    return state.session.optionsFilterPartyRegisterDatePartiesServices
  },
  optionsFilterPartyBuyerPartiesServices: state => {
    return state.session.optionsFilterPartyBuyerPartiesServices
  },
  optionsFilterPartyPropietaryPartiesServices: state => {
    return state.session.optionsFilterPartyPropietaryPartiesServices
  },
  optionsFilterPartySellerPartiesServices: state => {
    return state.session.optionsFilterPartySellerPartiesServices
  },
  optionsFilterPartyActivePartiesServices: state => {
    return state.session.optionsFilterPartyActivePartiesServices
  },
  optionsFilterPartyCountryPartiesServices: state => {
    return state.session.optionsFilterPartyCountryPartiesServices
  }
}

// actions
const actions = {
  // Crear key Usuario
  setUserNameServ ({ state }) {
    // Manda el username a las computadas para su comprobacion en el storage
    const B2bUserConfigSession = JSON.parse(sessionStorage.getItem('store'))
    state.userConfigLocalStorage = B2bUserConfigSession.activeUser.data.username
    if (JSON.parse(localStorage.getItem(state.userConfigLocalStorage))) {
      state.local = setByUserLocalServ()
    }
  },
  async isNewVersionServiciosLocalState ({ state }, localStorage) {
    const isnew = fn.isNewVersion(state, localStorage.servicios)
    return isnew
  },
  /* SERVICIOS
  * Servicio para traer los proyectos.
  * Se utiliza también para ordenar la tabla, la paginación,
  * el tamaño de la tabla y los filtros.
  */
  async getServices ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      console.log('RESPONSE getServices:: ', response)

      commit('SERVICES_STATE', {
        tableData: response.data.content,
        totalServices: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  selectService ({ commit }, service) {
    return new Promise((resolve) => {
      commit('SELECTED_SERVICE', service)
      resolve()
    })
  },

  /* Modifica un  servicio */
  async modifyService ({ commit, rootState }, { serviceId, params }) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/project/' + serviceId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: params
      })

      console.log('RESPONSE modifyService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Detalles Servicios
  async getServiceDetail ({ commit, rootState }, serviceId) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + serviceId
      })

      console.log('RESPONSE getService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /** Agrega un logo a un servicio */
  async addLogoService ({ commit, rootState }, params) {
    try {
      const formData = new FormData()
      formData.append('logo', params.logo.raw)
      console.log('params: ', params)
      console.log('formData: ', formData)

      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/logo',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: formData
      })

      console.log('RESPONSE addLogoService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina el logo de un servicio  */
  async deleteLogoService ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/logo'
      })

      console.log('RESPONSE deleteLogoService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /** Descarga el logo de una servicio  */
  async downloadLogoService ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/logo',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob'
      })

      console.log('RESPONSE downloadLogoService:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = ''
      const fileGroup = /([^;]+;\s+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }

      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina Datos de configuración de un  servicio */
  async removeDataConfiguration ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/project/' + params.serviceId + '/configuration/' + params.dataconfigurationId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE removeDataConfiguration:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega datos de configuración de un proyecto */
  async addProjectConfiguration ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/configuration',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          id: params.configurationId,
          type: params.type,
          value: params.value
        }
      })

      console.log('RESPONSE addProjectConfiguration:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
   // Datos de configuración mime
   async getMimeConfiguration ({ commit, rootState }, serviceId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + serviceId + '/mimeconfiguration',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE getMimeConfiguration:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
   /* Elimina Datos de configuración mime de un  servicio */
   async removeMimeConfiguration ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/project/' + params.serviceId + '/mimeconfiguration/' + params.dataconfigurationMimeId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE removeMimeConfiguration:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega datos de configuración de un proyecto */
  async addMimeConfiguration ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/mimeconfiguration',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          projectId:params.serviceId,
          mimeFrom: params.mimeFrom,
          mimeSender: params.mimeSender,
          mimeReplyTo: params.mimeReplyTo
        }
      })

      console.log('RESPONSE addMimeConfiguration:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Añade una nueva vigencia a un proyecto */
  async addValidity ({ commit, rootState }, params) {
    try {
      if (params.role === 'AS_SELLER') {
        params.role = true
      } else if (params.role === 'AS_BUYER') {
        params.role = false
      }
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/validities',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          country: params.country,
          documentType: params.documentType,
          sender: params.role,
          validity: params.validity
        }
      })

      console.log('RESPONSE addValidity:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Añade una nueva valicación a un proyecto */
  async addValidation ({ commit, rootState }, params) {
    try {
      if (params.role === 'AS_SELLER') {
        params.role = true
      } else if (params.role === 'AS_BUYER') {
        params.role = false
      } else {
        params.role = null
      }
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/validations',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          validationId: params.validationId,
          documentType: params.documentType,
          sender: params.role,
          value: params.value,
          documentFormat: params.documentFormat,
          country: params.country
        }
      })

      console.log('RESPONSE addValidation:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Obtiene los formatos para un tipo de documento */
  async getFormatByDocType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params + '/documentFormat'
      })

      console.log('RESPONSE getFormatByDocType:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Añade una nueva visualización PDF a un proyecto */
  async addPDFVisualization ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/pdfVisualize',
        data: {
          visualizationId: params.visualizationId,
          documentType: params.documentType,
          issueDirection: params.issueDirection,
          communicationmethodId: params.communicationsmethodsId
        }
      })

      console.log('RESPONSE addVisualization:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Añade una nueva tipología de correo a un servicio */
  async addProjectEmailType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/emailType',
        data: {
          emailTypeId: params.emailTypeId,
          emailValue: params.emailValue
        }
      })

      console.log('RESPONSE addProjectEmailType: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   /* Elimina Datos de configuración de un  servicio */
   async getDataConfigurationCode ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/configuration/' + params.dataconfigurationCode,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getDataConfigurationByCode:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getDataConfigurationValueByCode ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/configurationValue/' + params.dataconfigurationCode,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getDataConfigurationByCode:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Datos de configuración
  async getDataConfiguration ({ commit, rootState }, serviceId) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + serviceId + '/configuration',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getDataConfiguration:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Métodos de comunicación servicios para el upload
  async getCommunicationsMethodsUpload ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + data.serviceId + '/communicationsmethods/upload',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          sender: data.sender
        }
      })

      console.log('RESPONSE getCommunicationsMethods:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Métodos de comunicación servicios
  async getCommunicationsMethodsPartyCredentials ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + data.serviceId + '/communicationsmethodscredentials',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data
      })

      console.log('RESPONSE getCommunicationsMethods:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Métodos de comunicación servicios
  async getCommunicationsMethods ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + data.serviceId + '/communicationsmethods',
        params: {
          sender: data.sender
        }
      })

      console.log('RESPONSE getCommunicationsMethods:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Método para obtener los métodos de envío
  async getOptionsCommunicationsMethod ({
    commit, rootState
  }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/communications/' + data.projectId + '/' + data.idBuyer + '/' + data.idSeller,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   // Métodos de comunicación/credenciales de las empresas del servicios
   async getCommunicationsMethodCredentials ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + data.serviceId + '/communicationsmethodcredentials',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          sender: data.sender,
          idcommunication: data.idcommunication
        }
      })
      console.log('RESPONSE getCommunicationsMethodCredentials:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async addCommunicationsMethodCredentials({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/communicationsmethodscredentials',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          idPartySender: params.idPartySender,
          communicationsMethodId: params.communicationsmethodsId,
          user: params.user,
          password: params.password
        }
      })

      console.log('RESPONSE communicationsmethodscredentials:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    /* Elimina un método de comunicación */
    async removeCommunicationMethodCredentials ({ commit, rootState }, params) {
      try {
        const response = await axios({
          method: 'DELETE',
          url: '/project/' + params.serviceId + '/communicationsmethodscredentials/' + params.communicationsmethodsId,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL
        })

        console.log('RESPONSE removeCommunicationsMethod:: ', response)

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },


  // Validaciones de un servicio
  async getValidations ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + data.serviceId + '/validations',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          enable: data.enable
        }
      })

      console.log('RESPONSE getValidations: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Visualizaciones PDF de un servicio
  async getPDFVisualizations ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + data.serviceId + '/pdfVisualize'
      })

      console.log('RESPONSE getVPDFVisualizations:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // categorías de rechazo de un servicio
  async getRejectionCategories ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + data.serviceId + '/rejectioncategories'
      })
      console.log('RESPONSE getRejectionCategories: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Elimina la categoria de rechazo de un Servicio */
  async removeProjectRejectionCategory ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/rejectioncategories/' + params.categoryId
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Añade una categoria de rechazo a un proyecto */
  async addRejectionCategory ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/rejectioncategories',
        data: {
          categoryId: params.categoryId,
          visibleId: params.visibleId
        }
      })
      console.log('RESPONSE addRejectionCategory: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Tipologías de correo de un servicio
  async getEmailTypes ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + data.serviceId + '/emailType'
      })

      console.log('RESPONSE getEmailTypes:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  async getWebModules ({ commit, state }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/webmodule'
      })
      console.log('RESPONSE getWebModules: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getWebModules: ', error)
      throw error.response
    }
  },
  async getProjectStatusConfig ({ commit, state }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/projectconfigstatus',
        params: {
          projectId: data.serviceId,
          webmodule: data.webmodule
        }
      })
      console.log('RESPONSE getProjectStatusConfig: ', response)

      fn.assignJwt(commit, state.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('Status project config: ', error)
      throw error.response
    }
  },

  // estados de tareas pendientes de un servicio
  async getPendingTasks ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + data.serviceId + '/pendingtaskstatus'
      })

      console.log('RESPONSE getPendingTasks: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Descripciones de cargos y descuentos de un servicio (traemos los codigos)
  async getChargeDiscountCodesByProyect({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/project/${data.serviceId}/ChargeDiscountCodesByProyect`,
        params: { charge: data.charge }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getChargeDiscountCodesByProyect --- ', error?.response)
      throw error?.response || error
    }
  },

  // Tabla de cargos y descuentos por proyecto
  async getProjectChargeDiscountsByProyect ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/project/${data.serviceId}/charges-discounts`
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getProjectChargeDiscountsByProyect --- ', error?.response)
      throw error?.response || error
    }
  },
  async deleteProjectChargeDiscount ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/project/${data.serviceId}/charges-discounts/${data.rowId}`
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR deleteProjectChargeDiscount --- ', error?.response)
      throw error?.response || error
    }
  },
  async createProjectChargeDiscount ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: `/project/${data.serviceId}/charges-discounts`,
        data: { typeId: data.typeId }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR createProjectChargeDiscount --- ', error?.response)
      throw error?.response || error
    }
  },

  // Visualizaciones PDF de un tipo de documento
  async getDisplayDocuments ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: 'constant/displayDocuments/' + data.documentTypeId // Por lo antiguo -> url: '/displayDocuments/' + data.documentTypeId + '/documentType/'
      })

      console.log('RESPONSE getDisplayDocuments:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Visualizaciones PDF de un servicio
  async getDisplayLabels ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/displayLabels/' + data.documentTypeId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      console.log('RESPONSE getDisplayLabels:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina un estado de tareas pendientes para un Servicio */
  async removeProjectPendingTask ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/pendingtaskstatus/' + params.pendingtaskId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Añade un estado de tarea pendiente a un proyecto */
  async addPendingTask ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/pendingtaskstatus',
        data: {
          status: params.status,
          idModule: params.idModule
        }
      })

      console.log('RESPONSE PendingTask: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Vigencias de un servicio
  async getValidities ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + data.serviceId + '/validities'
      })

      console.log('RESPONSE getValidities: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Validaciones de una empresa
  async getPartyValidations ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/party/' + data.partyId + '/validations',
        params: {
          enable: data.enable
        }
      })

      console.log('RESPONSE getPartyValidations:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Añade una nueva valicación a una empresa */
  async addPartyValidation ({ commit, rootState }, params) {
    try {
      if (params.role === 'seller') {
        params.role = true
      } else if (params.role === 'buyer') {
        params.role = false
      } else {
        params.role = null
      }
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/party/' + params.partyId + '/validations',
        data: {
          validationId: params.validationId,
          documentType: params.documentType,
          sender: params.role,
          value: params.value,
          country: params.country,
          documentFormat: params.documentFormat,
          projectId: params.projectId
        }
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para llenar Select tipo de
   * Documento.
   */
  async getOptionsDocumentType ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/documenttype'
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getOptionsDocumentType --- ', error.response)
      throw error.response
    }
  },

  async getOptionsDeliveryNoteType ({
    commit, rootState
  }) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/deliverynotetype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getOptionsDeliveryNoteType --- ', error.response)
      throw error.response
    }
  },

  /* Agrega un método de comunicación */
  async addCommunicationsMethods ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/communicationsmethods',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          serviceId: params.serviceId,
          communicationsMethodId: params.communicationsmethodsId
        }
      })

      console.log('RESPONSE addCommunicationsMethods:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina un método de comunicación */
  async removeCommunicationsMethod ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/communicationsmethods/' + params.communicationsmethodsId
      })

      console.log('RESPONSE removeCommunicationsMethod:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina una validación para un Servicio */
  async removeProjectValidation ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/validations/' + params.validationId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina una tipología de correo para un Servicio */
  async removeProjectMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/emailType/' + params.projectMediaId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina una visualización PDF para un Servicio */
  async removeProjectPDFVisualization ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/pdfVisualize/' + params.visualizationId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina una vigencia para un Servicio */
  async removeProjectValidity ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/validities/' + params.validityId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Visualizaciones PDF de una empresa
  async getPartyPDFVisualizations ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + data.serviceId + '/party/' + data.partyId + '/pdfVisualize',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE getVPDFVisualizations:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
   /* Añade una nueva visualización PDF a una empresa */
   async addPartyPDFVisualization ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/pdfVisualize',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          visualizationId: params.visualizationId,
          documentType: params.documentType,
          issueDirection: params.issueDirection,
          communicationmethodId: params.communicationsmethodsId
        }
      })

      console.log('RESPONSE addVisualization:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async addPartyPaymentMeans ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/paymentMeans',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          swift: params.swift,
          iban: params.iban,
          paymentMeansId: params.paymentMeansId
        }
      })

      console.log('RESPONSE addPartyPaymentMeans:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

   /* Elimina una visualización PDF para una empresa */
   async removePartyPDFVisualization ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/pdfVisualize/' + params.visualizationId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina una validación para un Servicio */
  async removePartyValidation ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/party/' + params.partyId + '/validations/' + params.validationId
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para la actualización masiva de la razón social de las empresas
   */
  async updateMassiveParties  ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/updatenameparty',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: data.query
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR updateMassiveParties --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para la carga masiva de empresas
   */
  async massivePartiesUpload ({
    commit, rootState
  }, data) {
    console.log(data)
    const formData = new FormData()
    formData.append('file', data.file.raw)
    formData.append('projectId', data.service)
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/party/fromfile',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      })
      const jwt = response.headers.authorization
      if (jwt !== rootState.session.jwt) {
        axios.defaults.headers.common.Authorization = jwt
        commit('JWT_STATE', jwt)
      }
      return (response)
    } catch (error) {
      console.log('massivePartiesUpload: ', error)
      throw error.response
    }
  },
  /**
   * Servicio para la carga masiva de flujos de aprobación, niveles y usuarios de centros
   */
  async massiveApprovalFlowUpload ({
    commit, rootState
  }, data) {
    console.log(data)
    const formData = new FormData()
    formData.append('file', data.file.raw)
    formData.append('projectId', data.service)
    try {
      const response = await axios({
        method: 'POST',
        url: '/approval/fromfile',
        // baseURL: 'http://localhost:8084/edocs-rest/rest-api/v1',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      })
      const jwt = response.headers.authorization
      if (jwt !== rootState.session.jwt) {
        axios.defaults.headers.common.Authorization = jwt
        commit('JWT_STATE', jwt)
      }
      return (response)
    } catch (error) {
      console.log('massiveApprovalFlowUpload: ', error)
      throw error.response
    }
  },
  /**
   * Servicio para la carga masiva de centros de una empresa
   */
  async massiveCentresUpload ({
    commit, rootState
  }, data) {
    console.log(data)
    const formData = new FormData()
    formData.append('file', data.file.raw)
    formData.append('projectId', data.service)
    formData.append('partyId', data.party)
    try {
      const response = await axios({
        method: 'POST',
        url: '/centre/fromfile',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        // baseURL: 'http://localhost:8084/edocs-rest/rest-api/v1',
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: formData
      })
      const jwt = response.headers.authorization
      if (jwt !== rootState.session.jwt) {
        axios.defaults.headers.common.Authorization = jwt
        commit('JWT_STATE', jwt)
      }
      return (response)
    } catch (error) {
      console.log('massiveCentresUpload: ', error)
      throw error.response
    }
  },
  /* Empresas de un servicio PROJECTPARTIES */
  async getPartiesService ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/party',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data.query
      })

      response.data.content.forEach(row => {
        row.buyer = !!row.buyer
        row.seller = !!row.seller
        row.third = !!row.third
        row.sponsor = !!row.sponsor
        row.enable  = !!row.enable
      })
      commit('PARTIES_SERVICE_STATE', {
        tableData: response.data.content,
        totalPartiesService: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getProjectsParty ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/party/projectsparty',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: data
      })

      console.log('RESPONSE getProjectsParty:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  selectPartiesService ({ commit }, partiesService) {
    return new Promise((resolve) => {
      commit('SELECTED_PARTIES_SERVICE', partiesService)
      resolve()
    })
  },

  /* Modifica  el estado de una empresa(Habilita/Deshabilita) */
  async updateStatusPartiesService ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/project/party/enable',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          projectId: request.projectId,
          enable: request.enable
        },
        data: {
          projectId: request.projectId,
          enable: request.enable,
          partyId: request.partyId
        }
      })

      console.log('RESPONSE updateStatusPartiesService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }

    /*
    CONFLICTEXCEPTION
    case 409:
    errorSms = 'La empresa no existe o el usuario no puede acceder a ella.'
    */
  },

  /* Modifica  el estado de un proyecto(Habilita/Deshabilita) */
  async updateStatusProject ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/project/' + request.projectId + '/status',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          enable: request.enable
        }
      })

      console.log('RESPONSE updateStatusProject:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Modifica  un proyecto: se utiliza para actualizar el flag emisor/receptor */
  async updateProject ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/project/' + request.projectId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          code: request.code,
          enable: request.enable,
          contractorId: request.contractorId,
          isReceiver: request.isReceiver,
          isSender: request.isSender,
          name: request.name,
          securityCode: request.securityCode,
          facturar: request.facturar
        }
      })

      console.log('RESPONSE updateProject:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Modifica  un proyectparty */
  async updatePartiesService ({ commit, rootState }, request) {
    try {
      const response = await axios({
        method: 'PUT',
        url: '/project/' + request.projectId + '/party/rol',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          sponsor: request.sponsor,
          buyer: request.buyer,
          seller: request.seller,
          third: request.third,
          partyId: request.partyId
        }
      })

      console.log('RESPONSE updatePartiesService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR ----', error.response)
      throw error.response
    }
  },

  // Detalles de la empresa de un proyecto
  async getPartyService ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/party/' + params.partyId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          projectId: params.serviceId
        }
      })

      console.log('RESPONSE getPartyService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async validateNif ({
    commit,
    rootState
  }, params) {
    console.log('params: ', params)

    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.sendProject + '/party/' + params.partyId + '/validateNif',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          legalNif: params.legalNif,
          legalCountry: params.legalCountry
        }
      })
      console.log('RESPONSE getPartyService:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async getPartyDocumentFormat ({
    commit,
    rootState
  }, params) {
    console.log('params: ', params)
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.sendProject + '/party/' + params.idParty + '/documentFormat',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          type: params.type
        }
      })
      console.log('RESPONSE getPartyDocumentFormat:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para descargar pdf de una Factura
     * @param {*} idChangeData
     */
  async downloadModeloPdf ({
    commit,
    rootState
  }, params) {
    console.log('params: ', params)
    const formData = new FormData()

    const blobProjectPartyDataProfile = new Blob([JSON.stringify(params.projectPartyDataProfile)], { type: 'application/json' })
    formData.append('projectPartyDataProfile', blobProjectPartyDataProfile)
    console.log('formData: ', formData)

    try {
      let response = null
      response = await axios({
        method: 'POST',
        url: '/project/' + params.projectPartyDataProfile.sendProject + '/party/' + params.projectPartyDataProfile.partyId + '/downloadModel',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: params.projectPartyDataProfile,
        responseType: 'blob'
      })
      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'modelo_solicitud.pdf')
      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return filename
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Detalles de un projectparty
  async getProjectPartyService ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/projectparty',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getProjectPartyService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Detalles de un projectparty solo con la empresa
  async getProjectPartySponsorService ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/party/' + params.partyId + '/projectparty'
      })

      console.log('RESPONSE getProjectPartyOnlyPartySponsorService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // Detalles de la empresa en el objeto projectparty
  async getProjectPartyDetail ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/party/' + params.partyId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getProjectPartyOnlyPartySponsorService:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Obtiene si el usuario es sponsor
  async isPartySponsor ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.projectId + '/ispartysponsor',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          taxIdentificationNumber: params.taxIdentificationNumber
        }
      })

      console.log('RESPONSE isPartySponsor:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Obtiene si el usuario tiene permisos para modificar datos maestros de la empresa
  async canChangeMasterData ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.projectId + '/haschangedataauth',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE hasChangeDataAuth:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Obtiene si el usuario tiene permisos para modificar los roles de la empresa
  async canChangeRole ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.projectId + '/haschangeroleauth',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE hasChangeRoleAuth:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Datos de PartyMedia
  async getPartyMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/partymedia'
      })

      console.log('RESPONSE getPartyMedia:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // PARTYMEDIA
  /* Elimina un partymedia */
  async deletePartyMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/partymedia/' + params.partyMediaId
      })

      console.log('RESPONSE deletePartyMedia:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega un partymedia */
  async insertPartyMedia ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/partymedia',
        data: {
          mediaTypeId: params.mediaTypeId,
          documentTypeId: params.documentTypeId,
          value: params.value,
          buyer: params.buyer,
          seller: params.seller,
          third: params.third
        }
      })

      console.log('RESPONSE insertPartyMedia:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }

    /*
    CONFLICTEXCEPTION
    case 409:
    errorSms = 'El registro introducido no es válido,ya existe uno igual o ya no se pueden añadir más contactos de este tipo.'
    */
  },

  // Datos de PartyDocumentCycle
  async getPartyDocumentCycle ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/party/documentCycle',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: params
      })

      console.log('RESPONSE getPartyDocumentCycle:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
     * Servicio para llenar Select Filtro Formato tipo de
     * Documento.
     */
  async getOptionsDocumentCycleClassByDocumentType ({
    commit, rootState
  }, id) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype/' + id + '/documentcycle',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR getOptionsDocumentCycleClassByDocumentType --- ', error.response)
      throw error.response
    }
  },

  /* Elimina un PartyDocumentCycle */
  async deletePartyDocumentCycle ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentCycle/' + params.partyDocumentCycleId
      })
      console.log('RESPONSE deletePartyDocumentCycle:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina un PartyDocumentCycleClass */
  async deletePartyDocumentCycleClass ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentCycleClass/' + params.partyDocumentCycleClassId,
        params: {
          deletePartyDocumentCycle: params.deletePartyDocumentCycle
        }
      })
      console.log('RESPONSE deletePartyDocumentCycleClass:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Añade un ciclo de documentos asociado a una empresa (PartyDocumentCycle(Class)) */
  async addPartyDocumentCycle ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.projectId + '/party/' + params.partyBuyer + '/documentcycle',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          partyBuyerId: params.partyBuyer,
          partySellerId: params.partySeller,
          centreBuyerId: params.centreBuyer,
          sourceDocumentType: params.sourceDocumentType,
          destinationDocumentType: params.destinationDocumentType,
          documentCycleClassName: params.documentCycleClass,
          documentCycleClassSource: params.documentCycleClassSource,
          additionalClassValue: params.additionalClassValue
        }
      })

      console.log('RESPONSE addPartyDocumentCycle:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Datos de PartyGln
  async getPartyGln ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/partygln'
      })

      console.log('RESPONSE getPartyGln:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  // PARTYGLN
  /* Elimina un partygln */
  async deletePartyGln ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/partygln/' + params.partyglnId
      })
      console.log('RESPONSE deletePartyGln:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Agrega un partygln */
  async insertPartyGln ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/partygln',
        data: {
          physicalGln: params.physicalGln,
          typeId: params.typeCode
        }
      })
      console.log('RESPONSE insertPartyGln:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Métodos de comunicación empresa de un servicio
  async getCommunicationsMethodsParty ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/communicationsmethod',
        params: {
          sender: params.sender
        }
      })

      console.log('RESPONSE getCommunicationsMethodsParty:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Metodo que devuelve los servicios de una empresa
  async getProjectsByIdParty ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/party/' + params.partyId + '/allprojects',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        params: {
          urlName: params.urlName
        }
      })

      console.log('RESPONSE getProjectsByIdParty:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Detalles Servicios
  async getProjectByName ({ commit, rootState }, projectname) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: 'me/project/' + projectname + '/name'
      })

      console.log('RESPONSE getProjectByName:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error)
      throw error.response
    }
  },

  /* Agrega un método de comunicación */
  async insertCommunicationsMethodsParty ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/communicationsmethod',
        data: {
          communicationsMethodId: params.communicationsmethodsId,
          user: params.user,
          password: params.password,
          allProjects: params.allProjects,
          partyId: params.partyId,
          idCountry: params.idCountry
        }
      })

      console.log('RESPONSE insertCommunicationsMethodsParty:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }

    /*
    //CONFLICEXCEPTION
    case 409:
      errorSms = 'Ya existe un mismo método de comunicación con el mismo código asociado al proyecto y la empresa.'
    */
  },

  /* Elimina un método de comunicación */
  async deleteCommunicationsMethodsParty ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/communicationsmethod/' + params.communicationsmethodsId,
        data: {
          allProjects: params.allProjects,
          priority: params.priority,
          idCountry: params.idCountry ?? null
        }
      })

      console.log('RESPONSE deleteCommunicationsMethodsParty:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Métodos de documentos de firma delegada
  async getSingDocument ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentsign'
      })

      console.log('RESPONSE getSingDocument:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Documentos y formatos emiten o reciben
  async getProjectDocFormat ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/projectDocumentFormat',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getProjectDocFormat:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    // Elimina Documentos y formatos emiten o reciben
    async deleteProjectDocumentFormat ({ commit, rootState }, params) {
      try {
        const response = await axios({
          method: 'DELETE',
          url: '/project/' + params.serviceId + '/projectDocumentFormat/' + params.projectDocumentFormatId,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        })

        console.log('RESPONSE deleteProjectDocumentFormat:: ', response)
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

    //tipo de identificador GLN de la empresa
  async getPartyGlnType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/constant/glnType'
      })
      console.log('RESPONSE getPartyGlnType:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // FORMATO DE DOCUMENTO
  async getPartyDocFormat ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/partyDocumentFormat/' + params.partyId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      console.log('RESPONSE getPartyDocFormat:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Configuracion de matriculas para albaranes emitidos
  async getPartyDeliveryNoteConfig ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/deliveryNoteConfig',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      console.log('RESPONSE getPartyDeliveryNoteConfig:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

 /* Elimina una matricula asociada a la empresa para albaranes emitidos */
 async deletePartyEmissionDeliveryNoteConfig ({ commit, rootState }, params) {
  try {
    const response = await axios({
      method: 'DELETE',
      url: '/project/' + params.serviceId + '/party/' + params.partyId + '/deliveryNoteConfig/' + params.partyDeliveryNoteConfigId,
      baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
    })

    console.log('RESPONSE deletePartyEmissionDeliveryNoteConfig:: ', response)
    fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
    return response
  } catch (error) {
    console.log('ERROR --- ', error.response)
    throw error.response
  }
},

  // Configuracion de tipos de albaranes asociados a la empresa
  async getPartyDeliveryNoteType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/deliveryNoteType',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      console.log('RESPONSE getPartyDeliveryNoteType:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    // Configuracion de etiquetas asociadas a la empresa
    async getPartyLabel ({ commit, rootState }, params) {
      try {
        const response = await axios({
          method: 'GET',
          url: '/project/' + params.serviceId + '/party/' + params.partyId + '/labels',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        })

        console.log('RESPONSE getPartyLabel:: ', response)

        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response.data
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

 /* Elimina un tipo de albaran asociado a la empresa */
 async deletePartyDeliveryNoteType ({ commit, rootState }, params) {
  try {
    const response = await axios({
      method: 'DELETE',
      url: '/project/' + params.serviceId + '/party/' + params.partyId + '/deliveryNoteType/' + params.deliveryNoteTypeId,
      baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
    })

    console.log('RESPONSE deletePartyDeliveryNoteType:: ', response)
    fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
    return response
  } catch (error) {
    console.log('ERROR --- ', error.response)
    throw error.response
  }
},

 /* Elimina una etiqueta asociada a la empresa */
 async deletePartyDisplayLabel ({ commit, rootState }, params) {
  try {
    const response = await axios({
      method: 'DELETE',
      url: '/project/' + params.serviceId + '/party/' + params.partyId + '/displayLabels/' + params.labelId,
      baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
    })

    console.log('RESPONSE deletePartyDisplayLabel:: ', response)
    fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
    return response
  } catch (error) {
    console.log('ERROR --- ', error.response)
    throw error.response
  }
},

  // Configuracion de tipos de albaranes asociados al proyecto
  async getProjectDeliveryNoteType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/deliveryNoteType',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      console.log('RESPONSE getProjectDeliveryNoteType:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

 /* Elimina un tipo de albaran asociado al proyecto */
 async deleteProjectDeliveryNoteType ({ commit, rootState }, params) {
  try {
    const response = await axios({
      method: 'DELETE',
      url: '/project/' + params.serviceId + '/deliveryNoteType/' + params.deliveryNoteTypeId,
      baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
    })

    console.log('RESPONSE deleteProjectDeliveryNoteType:: ', response)
    fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
    return response
  } catch (error) {
    console.log('ERROR --- ', error.response)
    throw error.response
  }
},

  /* Elimina un FORMATO DE DOCUMENTO */
  async deletePartyDocumentFormat ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentFormat/' + params.partyDocumentFormatId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      console.log('RESPONSE deletePartyDocumentFormat:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega un FORMATO DE DOCUMENTO */
  async insertPartyDocumentFormat ({ commit, rootState }, params) {
    try {
      const dataFormartyDocumentFormat = params.partyDocumentFormat
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentFormat',
        data: {
          documentTypeId: dataFormartyDocumentFormat.documentType,
          documentFormatId: dataFormartyDocumentFormat.documentFormat,
          sender: dataFormartyDocumentFormat.senderId,
        }
      })

      console.log('RESPONSE insertPartyDocumentFormat:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega una matrícula para albaranes emitidos */
  async insertPartyDeliveryNoteConfig ({ commit, rootState }, params) {
    try {
      const dataPartyDeliveryNoteConfig = params.partyDeliveryNoteConfig
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/deliveryNoteConfig',
        data: {
          platformCode: dataPartyDeliveryNoteConfig.platformCode,
          partyPrefix: dataPartyDeliveryNoteConfig.partyPrefix,
          packSequenceNumber: dataPartyDeliveryNoteConfig.packSequenceNumber,
        }
      })
      console.log('RESPONSE insertPartyDeliveryNoteConfig:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega un tipo de albaran asociado a la empresa */
  async insertPartyDeliveryNoteType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/deliveryNoteType/' + params.deliveryNoteTypeId,
      })
      console.log('RESPONSE insertPartyDeliveryNoteType:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega un tipo de albaran asociado al proyecto */
  async insertProjectDeliveryNoteType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/deliveryNoteType/' + params.deliveryNoteTypeId,
      })
      console.log('RESPONSE insertProjectDeliveryNoteType:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

    /* Agrega un Documentos y formatos emiten o reciben */
    async insertProjectDocumentFormat ({ commit, rootState }, params) {
      try {
        const dataFormartyDocumentFormat = params.projectDocumentFormat
        const response = await axios({
          method: 'POST',
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          url: '/project/' + params.serviceId + '/projectDocumentFormat',
          data: {
            documentTypeId: dataFormartyDocumentFormat.documentType,
            documentFormatId: dataFormartyDocumentFormat.documentFormat,
            sender: dataFormartyDocumentFormat.senderId,
          }
        })

        console.log('RESPONSE insertProjectDocumentFormat:: ', response)
        fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
        return response
      } catch (error) {
        console.log('ERROR --- ', error.response)
        throw error.response
      }
    },

  /* Agrega una etiqueta asociada a la empresa */
  async insertPartyDisplayLabel ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/displayLabels/' + params.labelId,
      })
      console.log('RESPONSE insertPartyLabel:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },


  // TIPOS DE DOCUMENTOS
  async getPartyDocumentType ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/constant/documenttype',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
      })

      console.log('RESPONSE getPartyDocumentType:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina un documento de firma delegada */
  async deleteSingDocument ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentsign/' + params.singdocumentId
      })

      console.log('RESPONSE deleteSingDocument:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Descarga un documento de firma delegada */
  async downloadSingDocument ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentsign/' + params.singdocumentId + '/file',
        responseType: 'blob'
      })

      console.log('RESPONSE downloadSingDocument:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = ''
      const fileGroup = /([^;]+;\s+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }

      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega un documento de firma delegada */
  async addSignDocument ({ commit, rootState }, params) {
    try {
      const formData = new FormData()
      formData.append('file', params.file.raw)
      formData.append('partyId', params.partyId)
      formData.append('serviceId', params.serviceId)
      formData.append('allProjects', params.allProjects)
      console.log('params: ', params)
      console.log('formData: ', formData)

      const response = await axios({
        method: 'POST',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/documentsign',
        data: formData
      })

      console.log('RESPONSE addSignDocument:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }

  /*  case 409:
    errorSms = 'Ya existe un documento de delegación de firma para la empresa seleccionada.' */
  },

  // Métodos de documentos de datos fiscales
  async getAeatDocument ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentaeat'
      })

      console.log('RESPONSE getAeatDocument:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Descarga un documento de datos fiscales */
  async downloadAeatDocument ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/documentaeat/' + params.aeatdocumentId + '/file',
        responseType: 'blob'
      })

      console.log('RESPONSE downloadAeatDocument:: ', response)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = ''
      const fileGroup = /([^;]+;\s+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }

      FileSaver.saveAs(blob, filename)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Configuración de envío */
  async getPartyGlnConfiguration({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/glnconfiguration',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getGlnConfigurationParty:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Configuración de datos de pago */
  async getPartyPaymentMeans({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/paymentmeans',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getPartyPaymentMeans:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Añade una nueva configuración de envío a la empresa */
  async addGlnConfigurationParty({ commit, rootState }, params) {
    try {
      const dataGlnConfiguration = params.glnConfiguration
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/glnconfiguration',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: {
          documentFormatId: dataGlnConfiguration.documentFormat,
          documentTypeId: dataGlnConfiguration.documentType,
          sellerId: dataGlnConfiguration.partySeller,
          buyerId: dataGlnConfiguration.partyBuyer,
          deliveryCentreId: dataGlnConfiguration.deliveryPoint,
          glnSellerId: dataGlnConfiguration.partyGLNSeller,
          glnBuyerId: dataGlnConfiguration.partyGLNBuyer
        }
      })

      console.log('RESPONSE addGlnConfigurationParty:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina una configuración de envío de la empresa */
  async deleteGlnConfigurationParty({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/glnconfiguration/' + params.glnConfigurationId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE deleteGlnConfigurationParty:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  async deletePartyPaymentMeans({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/paymentMeans/' + params.paymentMeansId,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE deletePartyPaymentMeans:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Modifica las empresas de un proyecto y envia datos bancarios */
  async modifyProjectPartyProfile ({ commit, rootState }, params) {
    // Multipart Request
    console.log('params: ', params)
    const formData = new FormData()
    if (params.logo && params.logo != null) {
      formData.append('logo', params.logo.raw)
    }
    if (params.fichero && params.fichero != null) {
      formData.append('fichero', params.fichero.raw)
    }
    if (params.ficheroCertificado && params.ficheroCertificado != null) {
      formData.append('ficheroCertificado', params.ficheroCertificado.raw)
    }
    if (params.ficheroDatos && params.ficheroDatos != null) {
      formData.append('ficheroDatos', params.ficheroDatos.raw)
    }

    const blobProjectPartyDataProfile = new Blob([JSON.stringify(params.projectPartyDataProfile)], { type: 'application/json' })
    formData.append('projectPartyDataProfile', blobProjectPartyDataProfile)
    console.log('formData: ', formData)

    try {
      let response = null
      response = await axios({
        method: 'POST',
        url: '/party/' + params.projectPartyDataProfile.partyId + '/profile',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: { 'Content-Type': undefined },
        data: formData
      })
      console.log('RESPONSE modifyProjectPartyProfile:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Modifica las empresas de un proyecto  */
  async modifyProjectParty ({ commit, rootState }, params) {
    // Multipart Request
    console.log('params: ', params)
    const formData = new FormData()
    if (params.logo && params.logo != null) {
      formData.append('logo', params.logo.raw)
    }

    const blobProjectPartyData = new Blob([JSON.stringify(params.projectPartyData)], { type: 'application/json' })
    formData.append('projectPartyData', blobProjectPartyData)
    console.log('formData: ', formData)

    try {
      let response = null
      if (params.projectPartyData.serviceId) {
        response = await axios({
          method: 'POST',
          url: '/project/' + params.projectPartyData.serviceId + '/party/' + params.projectPartyData.partyId,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          headers: { 'Content-Type': undefined },
          data: formData
        })
      } else {
        response = await axios({
          method: 'POST',
          url: '/party/' + params.projectPartyData.partyId,
          baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
          headers: { 'Content-Type': undefined },
          data: formData
        })
      }

      console.log('RESPONSE modifyProjectParty:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /* Elimina el logo de una empresa  */
  async deleteLogoParty ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/logo'
      })

      console.log('RESPONSE deleteLogoParty:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina el logo de una empresa  */
  async deleteLogoOnlyParty ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'DELETE',
        url: '/party/' + params.partyId + '/logo',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })
      console.log('RESPONSE deleteLogoParty:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /** Descarga el logo de una empresa  */
  async downloadLogoParty ({ commit, rootState }, params) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/project/party/' + params.partyId + '/logo',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        responseType: 'blob',
        params: {
          projectId: params.serviceId
        }
      })

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })
      let filename = 'recadvs.csv'
      const fileGroup = /([^;]+;\s+)?filename="([^"]+)"$/.exec(response.headers['content-disposition'])
      if (fileGroup?.[2]) {
        filename = fileGroup[2]
      }

      FileSaver.saveAs(blob, filename)

      console.log('RESPONSE downloadLogoParty:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Creacion de una nueva relación entre proyecto y empresa,datos de contacto, roles y empresa si procede. */
  async createProjectParty ({ commit, rootState }, params) {
    // Multipart Request
    console.log('params: ', params)
    const formData = new FormData()
    if (params.logo && params.logo != null) {
      formData.append('logo', params.logo.raw)
    }

    // Asegurar que los campos booleanos no sean null
    const projectPartyData = {
      ...params.projectPartyData,
      sponsor: params.projectPartyData.sponsor ?? false,
      buyer: params.projectPartyData.buyer ?? false,
      seller: params.projectPartyData.seller ?? false,
      third: params.projectPartyData.third ?? false
    }

    const blobProjectPartyData = new Blob([JSON.stringify(projectPartyData)], { type: 'application/json' })
    formData.append('projectPartyData', blobProjectPartyData)
    console.log('formData: ', formData)

    try {
      const response = await axios({
        method: 'POST',
        url: '/project/' + params.projectPartyData.projectId + '/party',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        headers: { 'Content-Type': undefined },
        data: formData
      })

      console.log('RESPONSE createProjectParty:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Carga una empresa por su NIF
  async getPartyByTax ({ commit, rootState }, data) {
    try {
      const response = await axios({
        method: 'GET',
        url: '/party/partyTax/' + data.taxIdentificationNumber,
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL
      })

      console.log('RESPONSE getPartyByTax:: ', response)

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // Relaciones comerciales de la empresa de un servicio

  selectCommercialRelation ({ commit }, commercialRelation) {
    return new Promise((resolve) => {
      commit('SELECTED_COMMERCIAL_RELATION', commercialRelation)
      resolve()
    })
  },

  // Busqueda de relaciones comerciales
  async getCommercialRelation ({ commit, rootState }, data) {
    try {
      const response = await axios({
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        method: 'GET',
        url: '/project/' + data.query.serviceId + '/party/' + data.query.partyId + '/commercialrelation',
        params: data.query
      })

      console.log('RESPONSE getCommercialRelation:: ', response)
      commit('COMMERCIAL_RELATION_STATE', {
        tableData: response.data.content,
        totalCommercialRelation: response.data.totalElements
      })

      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response.data.content
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Elimina una relación comercial */
  async deleteCommercialRelation ({ commit, rootState }, params) {
    try {
      const response = await axios({
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        method: 'DELETE',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/commercialrelation/' + params.partycommercialrelationId
      })

      console.log('RESPONSEee deleteCommercialRelation:: ', response)
      fn.assignJwt(commit, rootState.session.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para llenar las empresas de relaciones comerciales por buyer y seller o ambos
   */
  async getOptionsPartyCommercialRelation ({ commit, rootState }, params) {
    try {
      const response = await axios({
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        method: 'GET',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/relationparty',
        params: params
      })

      console.log('RESPONSE getOptionsPartyCommercialRelation:: ', response)

      let optionsFilter = ''

      if (params.type === 'BUYER') {
        optionsFilter = response.data
        commit('OPTIONS_FILTER_PARTYBUYER_COMMERCIALRELATION', optionsFilter)
      } else if (params.type === 'SELLER') {
        optionsFilter = response.data
        commit('OPTIONS_FILTER_PARTYSELLER_COMMERCIALRELATION', optionsFilter)
      } else if (params.type === 'ALL') {
        optionsFilter = response.data
        commit('OPTIONS_FILTER_PARTYALL_COMMERCIALRELATION', optionsFilter)
      }

      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)
      return optionsFilter
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Agrega una relación comercial */
  async insertCommercialRelation ({ commit, rootState }, params) {
    try {
      const response = await axios({
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        method: 'POST',
        url: '/project/' + params.serviceId + '/party/' + params.partyId + '/commercialrelation',
        data: params
      })

      console.log('RESPONSE insertCommercialRelation:: ', response)

      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /**
   * Servicio para obtener los detalles de una relación comercial.
   */
  async getCommercialRelationDetail ({ commit, rootState }, params) {
    try {
      const response = await axios({
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/' + params.projectId + '/party/' + params.partyId + '/commercialrelation/' + params.partycommercialrelationId
      })

      console.log('RESPONSE getCommercialRelationDetail:: ', response)

      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  // CANALES  DE LAS RELACIONES COMERCIALES
  /**
   * Servicio para obtener los canales de las relaciones comerciales.
   */
  async getChannelRelationComertial ({ commit, rootState }, data) {
    try {
      const response = await axios({
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/channels',
        params: data
      })

      console.log('RESPONSE getChannelRelationComertial:: ', response)
      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },
  /**
   * Servicio para obtener los usuarios de los canales de las relaciones comerciales.
   */
  async getUserChannelRelationComertial ({ commit, rootState }, data) {
    try {
      const response = await axios({
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/channels/' + data.channelId + '/users',
        params: data
      })

      console.log('RESPONSE getUserChannelRelationComertial:: ', response)

      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)
      return response.data
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /* Creacion de un nuevo proyecto. */
  async createProject ({ commit, rootState }, params) {
    // Multipart Request
    console.log('params: ', params)
    const formData = new FormData()
    if (params.logo && params.logo != null) {
      formData.append('logo', params.logo.raw)
    }

    const blobProjectData = new Blob([JSON.stringify(params.projectData)], { type: 'application/json' })
    formData.append('projectData', blobProjectData)
    console.log('formData: ', formData)

    try {
      const response = await axios({
        method: 'POST',
        url: '/project',
        headers: { 'Content-Type': undefined },
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        data: formData
      })

      console.log('RESPONSE createProject:: ', response)

      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)
      return response
    } catch (error) {
      console.log('ERROR --- ', error.response)
      throw error.response
    }
  },

  /*
    * Servicio para exportar todos las empresas de un servicio en formato CSV
    */
  async downloadPartiesByServiceCsv ({
    commit, rootState
  }, params) {
    try {
      const response = await axios({
        method: 'GET',
        baseURL: process.env.VUE_APP_NEW_SERVICE_URL,
        url: '/project/party/service',
        params: params,
        headers: { 'Accept-Language': params.activeLang },
        responseType: 'blob',
        paramsSerializer: params => {
          return qs.stringify(convertDates(params), { indices: false })
        }
      })
      console.log('RESPONSE downloadPartiesByServiceCsv:: ', response)
      fn.assignJwt(commit, rootState.jwt, response.headers.authorization)

      const blob = new Blob([response.data], {
        type: response.headers['content-type']
      })

      const filename = fn.extractFilename(response.headers['content-disposition'], 'all-csv-parties-services.pdf')
      FileSaver.saveAs(blob, filename)
      return (filename)
    } catch (error) {
      console.log('downloadPartiesByServiceCsv: ', error.response)
      throw error.response
    }
  },

  // Datos Tabla Servicios
  servicesState: ({ commit }, payload) => {
    commit('SERVICES_STATE', payload)
  },
  queryServicesState: ({ commit }, payload) => {
    commit('QUERY_SERVICES_STATE', payload)
  },
  listSelectedFiltersServicesState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_SERVICES_STATE', payload)
  },

  // Columnas Tabla Servicios
  isShowNameServicesAction: ({ commit }, payload) => {
    commit('IS_SHOW_NAME_SERVICES', payload)
  },
  isShowCodeServicesAction: ({ commit }, payload) => {
    commit('IS_SHOW_CODE_SERVICES', payload)
  },
  isShowIsSenderServicesAction: ({ commit }, payload) => {
    commit('IS_SHOW_ISSENDER_SERVICES', payload)
  },
  isShowIsReceiverServicesAction: ({ commit }, payload) => {
    commit('IS_SHOW_ISRECEIVER_SERVICES', payload)
  },
  isShowCreationDateTimeServicesAction: ({ commit }, payload) => {
    commit('IS_SHOW_CREATIONDATETIME_SERVICES', payload)
  },
  isShowStatusServicesAction: ({ commit }, payload) => {
    commit('IS_SHOW_STATUS_SERVICES', payload)
  },

  // Datos Tabla Empresas de un servicio
  partiesServiceState: ({ commit }, payload) => {
    commit('PARTIES_SERVICE_STATE', payload)
  },
  queryPartiesServiceState: ({ commit }, payload) => {
    commit('QUERY_PARTIES_SERVICE_STATE', payload)
  },
  listSelectedFiltersPartiesServiceState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_PARTIES_SERVICE_STATE', payload)
  },

  // Datos Tabla Relaciones comerciales
  commercialRelationState: ({ commit }, payload) => {
    commit('COMMERCIAL_RELATION_STATE', payload)
  },
  queryCommercialRelationState: ({ commit }, payload) => {
    commit('QUERY_COMMERCIAL_RELATION_STATE', payload)
  },
  listSelectedFiltersCommercialRelationState: ({ commit }, payload) => {
    commit('LIST_SELECTED_FILTERS_COMMERCIAL_RELATION_STATE', payload)
  },

  // Columnas Tabla Empresas de un servicio
  isShowNameServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_NAME_SERVICE_PARTY', payload)
  },
  isShowTaxServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_TAX_SERVICE_PARTY', payload)
  },
  isShowEnabledServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_ENABLED_SERVICE_PARTY', payload)
  },
  isShowCountryServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_COUNTRY_SERVICE_PARTY', payload)
  },
  isShowSellerServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_SELLER_SERVICE_PARTY', payload)
  },
  isShowBuyerServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_BUYER_SERVICE_PARTY', payload)
  },
  isShowThirdServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_THIRD_SERVICE_PARTY', payload)
  },
  isShowSponsorServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_SPONSOR_SERVICE_PARTY', payload)
  },
  isShowProvinceServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_PROVINCE_SERVICE_PARTY', payload)
  },
  isShowCreationDateTimeServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_CREATIONDATETIME_SERVICE_PARTY', payload)
  },
  isShowRegisterServiceParty: ({ commit }, payload) => {
    commit('IS_SHOW_REGISTER_SERVICE_PARTY', payload)
  },

  // Columnas Relaciones Comerciales
  isShowBuyerNameCommercialRelation: ({ commit }, payload) => {
    commit('IS_SHOW_BUYERNAME_COMMERCIALRELATION', payload)
  },
  isShowSellerNameCommercialRelation: ({ commit }, payload) => {
    commit('IS_SHOW_SELLERNAME_COMMERCIALRELATION', payload)
  },
  isShowChannelCommercialRelation: ({ commit }, payload) => {
    commit('IS_SHOW_CHANNEL_COMMERCIALRELATION', payload)
  },

  // Datos Select Filtros Servicios
  optionsFilterNameServices: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_NAME_SERVICES', payload)
  },
  optionsFilterCodeServices: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CODE_SERVICES', payload)
  },
  optionsFilterSecurityCodeServices: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_SECURITYCODE_SERVICES', payload)
  },
  optionsFilterPartyNifServices: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYNIF_SERVICES', payload)
  },
  optionsFilterPartyNameServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYNAME_SERVICES', payload)
  },
  optionsFilterDateCreationServices: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_CREATIONDATE_SERVICES', payload)
  },
  optionsFilterPartyNamePartiesServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYNAME_PARTIESSERVICES', payload)
  },
  optionsFilterPartyTaxIdNumberPartiesServices: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYTAX_PARTIESSERVICES', payload)
  },
  optionsFilterPartyRegisterDatePartiesServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYREGISTERDATE_PARTIESSERVICES', payload)
  },
  optionsFilterPartyBuyerPartiesServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYBUYER_PARTIESSERVICES', payload)
  },
  optionsFilterPartyPropietaryPartiesServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYPROPIETARY_PARTIESSERVICES', payload)
  },
  optionsFilterPartySellerPartiesServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYSELLER_PARTIESSERVICES', payload)
  },
  optionsFilterPartyActivePartiesServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYACTIVE_PARTIESSERVICES', payload)
  },
  optionsFilterPartyCountryPartiesServicesState: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYCOUNTRY_PARTIESSERVICES', payload)
  },

  optionsFilterPartyAllCommercialRelation: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYALL_COMMERCIALRELATION', payload)
  },
  optionsFilterPartyBuyerCommercialRelation: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYBUYER_COMMERCIALRELATION', payload)
  },
  optionsFilterPartySellerCommercialRelation: ({ commit }, payload) => {
    commit('OPTIONS_FILTER_PARTYSELLER_COMMERCIALRELATION', payload)
  }
}

// mutations
const mutations = {
  resetSessionServicios (state) {
    state.session = initSession()
    state.local = initLocal()
  },
  // Funcion para definir el filtro rápido de fechas cuando se es superadmin
  /*
  servicesDatesSuperAdmin (state) {
    state.session.queryServices.creationDateTimeFrom = initDateFrom(1)
  },
  */
  // Datos Servicios
  'SERVICES_STATE' (state, payload) {
    state.session.services = payload
  },
  'QUERY_SERVICES_STATE' (state, payload) {
    state.session.queryServices = payload
  },
  'LIST_SELECTED_FILTERS_SERVICES_STATE' (state, payload) {
    state.session.listSelectedFiltersServices = payload
  },
  'SELECTED_SERVICE' (state, services) {
    state.session.services = services
  },

  // Datos empresas de un Servicio
  'PARTIES_SERVICE_STATE' (state, payload) {
    state.session.partiesService = payload
  },
  'QUERY_PARTIES_SERVICE_STATE' (state, payload) {
    state.session.queryPartiesService = payload
  },
  'LIST_SELECTED_FILTERS_PARTIES_SERVICE_STATE' (state, payload) {
    state.session.listSelectedFiltersPartiesService = payload
  },
  'SELECTED_PARTIES_SERVICE' (state, partiesService) {
    state.session.partiesService = partiesService
  },

  // Datos Relaciones comerciales
  'COMMERCIAL_RELATION_STATE' (state, payload) {
    state.session.commercialRelation = payload
  },
  'QUERY_COMMERCIAL_RELATION_STATE' (state, payload) {
    state.session.queryCommercialRelation = payload
  },
  'LIST_SELECTED_FILTERS_COMMERCIAL_RELATION_STATE' (state, payload) {
    state.session.listSelectedFiltersCommercialRelation = payload
  },
  'SELECTED_COMMERCIAL_RELATION' (state, commercialRelation) {
    state.session.commercialRelation = commercialRelation
  },

  // Columnas Tabla Servicios
  'IS_SHOW_NAME_SERVICES' (state, payload) {
    state.local.isShowNameServices = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowNameServices = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CODE_SERVICES' (state, payload) {
    state.local.isShowCodeServices = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowCodeServices = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ISSENDER_SERVICES' (state, payload) {
    state.local.isShowIsSenderServices = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowIsSenderServices = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ISRECEIVER_SERVICES' (state, payload) {
    state.local.isShowIsReceiverServices = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowIsReceiverServices = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATIONDATETIME_SERVICES' (state, payload) {
    state.local.isShowCreationDateTimeServices = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowCreationDateTimeServices = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_STATUS_SERVICES' (state, payload) {
    state.local.isShowStatusServices = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowStatusServices = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // Columnas Tabla Empresas de un Servicio
  'IS_SHOW_NAME_SERVICE_PARTY' (state, payload) {
    state.local.isShowNameServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowNameServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_TAX_SERVICE_PARTY' (state, payload) {
    state.local.isShowTaxServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowTaxServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_ENABLED_SERVICE_PARTY' (state, payload) {
    state.local.isShowEnabledServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowEnabledServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_COUNTRY_SERVICE_PARTY' (state, payload) {
    state.local.isShowCountryServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowCountryServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLER_SERVICE_PARTY' (state, payload) {
    state.local.isShowSellerServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowSellerServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_BUYER_SERVICE_PARTY' (state, payload) {
    state.local.isShowBuyerServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowBuyerServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_THIRD_SERVICE_PARTY' (state, payload) {
    state.local.isShowThirdServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowThirdServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SPONSOR_SERVICE_PARTY' (state, payload) {
    state.local.isShowSponsorServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowSponsorServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_PROVINCE_SERVICE_PARTY' (state, payload) {
    state.local.isShowProvinceServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowProvinceServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CREATIONDATETIME_SERVICE_PARTY' (state, payload) {
    state.local.isShowCreationDateTimeServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowCreationDateTimeServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_REGISTER_SERVICE_PARTY' (state, payload) {
    state.local.isShowRegisterServiceParty = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowRegisterServiceParty = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // Columnas Relaciones comerciales
  'IS_SHOW_BUYERNAME_COMMERCIALRELATION' (state, payload) {
    state.local.isShowBuyerNameCommercialRelation = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowBuyerNameCommercialRelation = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_SELLERNAME_COMMERCIALRELATION' (state, payload) {
    state.local.isShowSellerNameCommercialRelation = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowSellerNameCommercialRelation = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },
  'IS_SHOW_CHANNEL_COMMERCIALRELATION' (state, payload) {
    state.local.isShowChannelCommercialRelation = payload
    const storeuser = JSON.parse(localStorage.getItem(state.userConfigLocalStorage))
    storeuser.servicios.isShowChannelCommercialRelation = payload
    localStorage.setItem(state.userConfigLocalStorage, JSON.stringify(storeuser))
  },

  // Datos Select Filtros Servicios
  'OPTIONS_FILTER_NAME_SERVICES' (state, payload) {
    state.session.optionsFilterNameServices = payload
  },
  'OPTIONS_FILTER_CODE_SERVICES' (state, payload) {
    state.session.optionsFilterCodeServices = payload
  },
  'OPTIONS_FILTER_SECURITYCODE_SERVICES' (state, payload) {
    state.session.optionsFilterSecurityCodeServices = payload
  },
  'OPTIONS_FILTER_PARTYNIF_SERVICES' (state, payload) {
    state.session.optionsFilterPartyNifServices = payload
  },
  'OPTIONS_FILTER_PARTYNAME_SERVICES' (state, payload) {
    state.session.optionsFilterPartyNameServices = payload
  },
  'OPTIONS_FILTER_CREATIONDATE_SERVICES' (state, payload) {
    state.session.optionsFilterDateCreationServices = payload
  },
  'OPTIONS_FILTER_PARTYNAME_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartyNamePartiesServices = payload
  },
  'OPTIONS_FILTER_PARTYTAX_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartyTaxIdNumberPartiesServices = payload
  },
  'OPTIONS_FILTER_PARTYREGISTERDATE_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartyRegisterDatePartiesServices = payload
  },
  'OPTIONS_FILTER_PARTYBUYER_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartyBuyerPartiesServices = payload
  },
  'OPTIONS_FILTER_PARTYPROPIETARY_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartyPropietaryPartiesServices = payload
  },
  'OPTIONS_FILTER_PARTYSELLER_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartySellerPartiesServices = payload
  },
  'OPTIONS_FILTER_PARTYACTIVE_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartyActivePartiesServices = payload
  },
  'OPTIONS_FILTER_PARTYCOUNTRY_PARTIESSERVICES' (state, payload) {
    state.session.optionsFilterPartyCountryPartiesServices = payload
  },

  'OPTIONS_FILTER_PARTYALL_COMMERCIALRELATION' (state, payload) {
    state.session.optionsFilterPartyAllCommercialRelation = payload
  },
  'OPTIONS_FILTER_PARTYBUYER_COMMERCIALRELATION' (state, payload) {
    state.session.optionsFilterPartyBuyerCommercialRelation = payload
  },
  'OPTIONS_FILTER_PARTYSELLER_COMMERCIALRELATION' (state, payload) {
    state.session.optionsFilterPartySellerCommercialRelation = payload
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
